import { of } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { epic } from '@legacyApp/client/modules/app/epicService';
import { REGISTRY_PERFORMANCE_PACKAGE } from '@legacyApp/client/store/registry/registry.constants';
import { adaptAppToLowPerformance, performanceTest } from './performance.thunk';
import { PERFORMANCE_SET_IS_LOW_PERFORMANCE } from './performance.constants';

const packageInjectedEpic = epic('packageInjectedEpic', {
	actions: (ofType) => ofType(REGISTRY_PERFORMANCE_PACKAGE),
	callback: () => {
		return of(performanceTest());
	},
});

const performanceCheckedEpic = epic('performanceCheckedEpic', {
	actions: (ofType) => ofType(PERFORMANCE_SET_IS_LOW_PERFORMANCE),
	callback: ({ action }) => {
		if (action.payload === false) {
			return of();
		}
		return of(adaptAppToLowPerformance());
	},
});

const performanceEpic = combineEpics(
	packageInjectedEpic,
	performanceCheckedEpic,
);

export default performanceEpic;
